import store from "@/store";
export const brandConfigObjectMap = new Map();

export const Brands = {
    VodacomStopClock: 3,
    VodacomQuizInc: 5,
    VodacomUnlockThree: 6,
    VodacomFantasyDribble: 8,
    VodacomBeatTheJams: 18,
    VodacomHeadToHead: 21,
    VodacomDailyFive: 25,
    VodacomCricketZone: 26,
    VodacomMotorsportZone: 27,
    VodacomRugbyZone: 28,
    VodacomChessMasters: 36,
    VodacomOpenly: 38,
    VodacomGameZar: 39,
    VodacomRoFantasyDribble: 88,
};

export const GameToBrandMap = new Map();
GameToBrandMap.set(3, Brands.VodacomStopClock);
GameToBrandMap.set(5, Brands.VodacomQuizInc);
GameToBrandMap.set(6, Brands.VodacomUnlockThree);
GameToBrandMap.set(8, Brands.VodacomFantasyDribble);
GameToBrandMap.set(18, Brands.VodacomBeatTheJams);
GameToBrandMap.set(21, Brands.VodacomHeadToHead);
GameToBrandMap.set(25, Brands.VodacomDailyFive);
GameToBrandMap.set(26, Brands.VodacomCricketZone);
GameToBrandMap.set(27, Brands.VodacomMotorsportZone);
GameToBrandMap.set(28, Brands.VodacomRugbyZone);
GameToBrandMap.set(38, Brands.VodacomOpenly);
GameToBrandMap.set(36, Brands.VodacomChessMasters);
GameToBrandMap.set(39, Brands.VodacomGameZar);
GameToBrandMap.set(88, Brands.VodacomRoFantasyDribble);

brandConfigObjectMap.set(Brands.VodacomDailyFive, {
    gameTitle: 'Daily 5',
    gameTag: 'daily-five',
    serviceId: 'vc-fanclash-quizinc-01',
    gameUrl: `https://dailyfivetrivia.co.za`,
    termsConditionsUrl: `https://dailyfivetrivia.co.za`,
    productId: 25,
    brand: 'vc-za-daily-five',
    newSelectVoucherLayout: true,
    rewardPopUp: true,
    rewardPopUpImage: require('./vc-za-daily-five/assets/background/popUp.webp'),
    footerTextColor: '#ffffff',
    styleOptions: {
        textColor: '#ffffff'
    }
});

brandConfigObjectMap.set(Brands.VodacomFantasyDribble, {
    gameTitle: 'FantasyDribble',
    gameTag: 'fantasy-dribble',
    serviceId: 'vc-fanclash-fl-football-free',
    gameUrl: 'https://fantasydribble.com',
    termsConditionsUrl: 'https://termsandconditions.vodacomfantasy.com',
    productId: 8,
    brand: 'vc-za-fantasy-dribble',
    walletIcon: require('./vc-za-fantasy-dribble/assets/Fantasy Dribble/wallet-icon.png'),
    redeemButton: require('./vc-za-fantasy-dribble/assets/Fantasy Dribble/redeem-pin-button.png'),
    selectVoucherBackground: require('./vc-za-fantasy-dribble/assets/background/fantasy-bg.webp'),
    newSelectVoucherLayout: true,
    footerTextColor: '#e0e0e0',
    styleOptions: {
        textColor: '#000000',
        accentColor: '#ff0000',
        secondaryAccentColor: '#ff0000'
    }
});

const roVoucherIconCtx = require.context('./ro-fantasy-dribble/assets/icons', true, /\.webp$/);
const roVoucherIcons = (key) => ({
    active: roVoucherIconCtx(`./active/${key}.webp`),
    activeSelected: roVoucherIconCtx(`./active-selected/${key}.webp`),
    inactive: roVoucherIconCtx(`./inactive/${key}.webp`),
    inactiveSelected: roVoucherIconCtx(`./inactive-selected/${key}.webp`),
});

brandConfigObjectMap.set(Brands.VodacomRoFantasyDribble, {
    gameTitle: 'Fantasy League',
    gameTag: 'ro-fantasy-dribble',
    serviceId: 'vc-fanclash-fl-football-free',
    gameUrl: 'https://ro.fantasyfootball.one/',
    termsConditionsUrl: 'https://termsandconditions.vodacomfantasy.com',
    productId: 88,
    brand: 'ro-fantasy-dribble',
    languageId: 'ro',
    walletIcon: require('./ro-fantasy-dribble/assets/coin-icon.webp'),
    couponIcon: require('./ro-fantasy-dribble/assets/coupon-icon.webp'),
    logo: require('./ro-fantasy-dribble/assets/logo/romanian-logo.png'),
    logoSmall: require('./ro-fantasy-dribble/assets/logo/logo-small.png'),
    selectVoucherBackground: require('./ro-fantasy-dribble/assets/background/page-background.webp'),
    popUpCardBackground: require('./ro-fantasy-dribble/assets/background/pop-up-card-background.webp'),
    newSelectVoucherLayout: true,
    noRedeemPin: true,
    useCoinsWallet: true,
    walletLabel: 'Wallet',
    skipOtpAuth: true,
    defaultRoute: 'SelectVoucher',
    allowedRoutes: ['SelectVoucher', 'MenuPage', 'CouponsPage', 'CouponValidityPage', 'TermsConditionsPage', 'ErrorPage', 'VoucherClaimed'],
    disallowedRoutes: ['RequestOtp', 'SubmitOtp', 'RedeemPin', 'HowToRedeemPage'],
    externalRedirectUrl: 'https://ro.fantasyfootball.one/',
    voucherStoreUrl: 'https://voucher-store-ro.fantasyfootball.one',
    headingPrimary: 'Claim your cool reward',
    headingPrimaryEmphasis: 'reward',
    headingSecondary: 'Please select which coupon you would like.',
    footerTextColor: '#e0e0e0',
    styleOptions: {
        textColor: '#ffffff',
        accentColor: '#E7151C',
        secondaryAccentColor: '#F51637'
    },
    voucherIcons: {
        148: roVoucherIcons('pubg-60uc'),
        149: roVoucherIcons('pubg-660uc'),
        150: roVoucherIcons('eafc-xbox'),
        151: roVoucherIcons('eafc-pc'),
        152: roVoucherIcons('xbox'),
        153: roVoucherIcons('psn'),
    },
});

brandConfigObjectMap.set(Brands.VodacomRugbyZone, {
    gameTitle: 'RugbyZone',
    gameTag: 'rugby-zone',
    serviceId: 'vc-fanclash-vodacom-fl-rugby-daily-01',
    gameUrl: 'https://rugby-zone.co.za',
    termsConditionsUrl: 'https://rugby-zone.co.za/terms-and-conditions',
    productId: 28,
    brand: 'vc-za-rugby-zone',
    selectVoucherBackground: require('./vc-za-rugby-zone/assets/background/rugbyzone-bg.webp'),
    newSelectVoucherLayout: true,
    redeemButton: require('./vc-za-qi/assets/buttons/inactive-redeem-button.png'),
    footerTextColor: '#e0e0e0'
});

brandConfigObjectMap.set(Brands.VodacomCricketZone, {
    gameTitle: 'CricketZone',
    gameTag: 'cricket-zone',
    serviceId: 'vc-fanclash-vodacom-fl-cricket-daily-01',
    gameUrl: 'https://cricketzone.co.za',
    termsConditionsUrl: 'https://cricketzone.co.za/terms-and-conditions',
    productId: 26,
    brand: 'vc-za-cricket-zone',
    selectVoucherBackground: require('./vc-za-cricket-zone/assets/background/cricket-bg.webp'),
    newSelectVoucherLayout: true,
    redeemButton: require('./vc-za-qi/assets/buttons/inactive-redeem-button.png'),
    footerTextColor: '#000',
    styleOptions: {
        textColor: '#000000',
        accentColor: '#ff0000'
    }
});

brandConfigObjectMap.set(Brands.VodacomMotorsportZone, {
    gameTitle: 'MotorsportZone',
    gameTag: 'motorsport-zone',
    serviceId: 'vc-fanclash-vodacom-fl-motorsport-daily-01',
    gameUrl: 'https://motorsportzone.co.za',
    termsConditionsUrl: 'https://motorsportzone.co.za/terms-and-conditions',
    productId: 27,
    brand: 'vc-za-motorsport-zone',
    selectVoucherBackground: require('./vc-za-motorsport-zone/assets/background/motorsport-bg.webp'),
    newSelectVoucherLayout: true,
    redeemButton: require('./vc-za-qi/assets/buttons/inactive-redeem-button.png'),
    footerTextColor: '#e0e0e0'
});

brandConfigObjectMap.set(Brands.VodacomQuizInc, {
    gameTitle: 'Quizinc',
    gameTag: 'quiz-inc',
    serviceId: 'vc-fanclash-quizinc-01',
    gameUrl: 'https://quizinc.co.za',
    termsConditionsUrl: 'https://termsandconditions.quizinc.co.za/quiz-inc',
    productId: 5,
    brand: 'vc-za-qi',
    footerTextColor: '#e0e0e0',
    selectVoucherBackground: require('./vc-za-qi/assets/background/selectVoucher-background.webp'),
    newSelectVoucherLayout: true,
    rewardPopUp: true,
    rewardPopUpImage: require('./vc-za-qi/assets/background/popUp.webp'),
});

brandConfigObjectMap.set(Brands.VodacomStopClock, {
    gameTitle: 'Stop the Clock',
    gameTag: 'stop-the-clock',
    serviceId: 'vc-fanclash-quizinc-03',
    gameUrl: 'https://stopclock.co.za',
    termsConditionsUrl: 'https://termsandconditions.quizinc.co.za/stop-the-clock',
    productId: 3,
    brand: 'vc-za-stc',
    footerTextColor: '#e0e0e0'
});

brandConfigObjectMap.set(Brands.VodacomUnlockThree, {
    gameTitle: 'Unlock 3',
    gameTag: 'unlock-3',
    serviceId: 'vc-fanclash-quizinc-05',
    gameUrl: 'https://unlock3.co.za',
    termsConditionsUrl: 'https://termsandconditions.quizinc.co.za/unlock-three',
    productId: 6,
    brand: 'vc-za-u3',
    footerTextColor: '#e0e0e0'
});

brandConfigObjectMap.set(Brands.VodacomHeadToHead, {
    gameTitle: 'QuizInc Head 2 Head',
    gameTag: 'head-2-head',
    serviceId: 'vc-fanclash-quizinc-04',
    gameUrl: 'https://quizhead2head.co.za',
    termsConditionsUrl: 'https://termsandconditions.quizinc.co.za/head-to-head',
    productId: 21,
    brand: 'vc-za-h2h',
    footerTextColor: '#e0e0e0',
    selectVoucherBackground: require('./vc-za-h2h/assets/background/selectVoucher-background.webp'),
    newSelectVoucherLayout: true,
    rewardPopUp: true,
    rewardPopUpImage: require('./vc-za-h2h/assets/background/popUp.webp'),
});

brandConfigObjectMap.set(Brands.VodacomBeatTheJams, {
    gameTitle: 'Beat the Jams',
    gameTag: 'beat-the-jams',
    serviceId: 'vc-fanclash-beatthejams-01',
    gameUrl: 'https://beatthejams.co.za',
    termsConditionsUrl: 'https://www.beatthejams.co.za/terms-and-conditions',
    productId: 18,
    brand: 'vc-za-btj',
    footerTextColor: '#e0e0e0',
    newSelectVoucherLayout: true,
    rewardPopUp: true,
    rewardPopUpImage: require('./vc-za-btj/assets/background/popUp.webp'),
});
brandConfigObjectMap.set(Brands.VodacomGameZar, {
    gameTitle: 'GameZar',
    gameTag: 'gamezar',
    serviceId: 'p-GameZAR',
    gameUrl: 'https://gamezar.co.za',
    termsConditionsUrl: 'https://gamezar.co.za/terms-and-conditions',
    productId: 39,
    brand: 'vc-za-gamezar',
    selectVoucherBackground: require('./vc-za-gamezar/assets/background/background-gamezar.png'),
    walletIcon: require('./vc-za-gamezar/assets/icons/wallet-icon-white.png'),
    footerTextColor: '#e0e0e0',
    newSelectVoucherLayout: true,
    rewardPopUp: true,
    rewardPopUpImage: require('./vc-za-gamezar/assets/background/popUp.webp'),
});
brandConfigObjectMap.set(Brands.VodacomChessMasters, {
    gameTitle: 'Chess Masters',
    gameTag: 'chess-masters',
    serviceId: 'vc-fanclash-quizinc-cm-f-daily-02',
    gameUrl: 'https://chessmasters.co.za',
    termsConditionsUrl: 'https://staging.chessmasters.co.za/terms',
    productId: 36,
    brand: 'vc-za-chess-masters',
    footerTextColor: '#e0e0e0',
    newSelectVoucherLayout: true,
    rewardPopUp: true,
    rewardPopUpImage: require('./vc-za-chess-masters/assets/background/popUp.webp'),
});
brandConfigObjectMap.set(Brands.VodacomChessMasters, {
    gameTitle: 'Chess Masters',
    gameTag: 'chess-masters',
    serviceId: 'vc-fanclash-quizinc-cm-f-daily-02',
    gameUrl: 'https://chessmasters.co.za',
    termsConditionsUrl: 'https://staging.chessmasters.co.za/terms',
    productId: 36,
    brand: 'vc-za-chess-masters',
    footerTextColor: '#e0e0e0',
    newSelectVoucherLayout: true,
    rewardPopUp: true,
    rewardPopUpImage: require('./vc-za-chess-masters/assets/background/popUp.webp'),
});

brandConfigObjectMap.set(Brands.VodacomOpenly, {
    gameTitle: 'Openly',
    gameTag: 'openly',
    serviceId: 'vc-paradigmconnect-openly-daily-02',
    gameUrl: 'https://app.openly.space',
    termsConditionsUrl: 'https://app.openly.space/onboarding/policies/termsAndConditions',
    productId: 38,
    brand: 'vc-za-openly',
    footerTextColor: '#e0e0e0',
    styleOptions: {
        textColor: '#000000',
        accentColor: '#c00c0d',
        secondaryAccentColor: '#979d82',
        backgroundColor: 'transparent'
    }
});
